import * as types from '../constants/action-types';

export const failedAction = (message) => {
    return {
        type: types.FAILED_ACTION,
        message: message
    };
};

export const successAction = (message) => {
    return {
        type: types.SUCCESS_ACTION,
        message: message
    };
};

export const clearMessage = () => {
    return {
        type: types.CLEARED_MESSAGE
    };
};
